import React from 'react';
import { useFormContext, ValidationIndicator, FieldHintAndError } from '@/components/form';
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";

const FormTextarea = ({
  name = "_",
  label,
  validators,
  required = false,
  placeholder,
  hint,
  className
}) => {
  const form = useFormContext();

  const requiredValidator = ({ value }) => {
    if (required && (!value || value.toString().trim() === '')) {
      console.log(`Validation error for field "${name}": ${value} This field is required`);
      return 'This field is required';
    }
    return undefined;
  };

  const finalValidators = {
    // Always include onBlur for required validation
    onBlur: ({ value }) => {
      const requiredError = requiredValidator({ value });
      if (requiredError) return requiredError;
      
      // If there's a custom onBlur validator, run it too
      if (validators?.onBlur) {
        return validators.onBlur({ value });
      }
      
      return undefined;
    },
    // Spread all other validators (like onChangeAsync, onChangeAsyncDebounceMs, etc.)
    ...(validators || {})
  };

  return (
    <form.Field
      name={name}
      validators={finalValidators}
    >
      {(field) => {
        const hasError = field.state.meta.isTouched && field.state.meta.errors.length > 0;

        return (
          <div className={cn("space-y-2", className)}>
            <Label
              htmlFor={field.name}
              className={hasError ? 'text-destructive' : ''}
            >
              {label}
              {(required || validators) && (
                <span className={hasError ? 'text-destructive' : 'text-muted-foreground'}>
                  {' *'}
                </span>
              )}
            </Label>
            <div className="relative">
              <Textarea
                id={field.name}
                value={field.state.value}
                onChange={(e) => field.handleChange(e.target.value)}
                onBlur={field.handleBlur}
                placeholder={placeholder}
                className={hasError ? 'border-destructive focus:ring-destructive' : ''}
              />
              <ValidationIndicator field={field} />
            </div>
            <FieldHintAndError field={field} hint={hint} />
          </div>
        );
      }}
    </form.Field>
  );
};

export default FormTextarea;
export { FormTextarea };
